var React = require('react');

function IconArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.057 8.961a.534.534 0 01-.182-.42.62.62 0 01.183-.441l2.476-2.475H.958a.631.631 0 01-.625-.648.62.62 0 01.625-.602h10.576L9.059 1.9a.625.625 0 11.884-.884l3.542 3.542a.625.625 0 010 .884L9.943 8.984a.61.61 0 01-.886-.023z","fill":"currentColor"}));
}

IconArrowRightInline.defaultProps = {"width":"14","height":"10","fill":"none"};

module.exports = IconArrowRightInline;

IconArrowRightInline.default = IconArrowRightInline;
